// src/components/common/CloseButtonSidePanel.tsx
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@/icons';
import './CloseButtonSidePanel.css';

interface CloseButtonSidePanelProps {
  onClick: () => void;
  disabled?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

const CloseButtonSidePanel: React.FC<CloseButtonSidePanelProps> = ({
  onClick,
  disabled = false,
  className = '',
  style,
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`close-button ${className}`}
      style={style}
    >
      <FontAwesomeIcon icon={faXmark} />
    </button>
  );
};

export default CloseButtonSidePanel;
